export const useClientToast = () => {
  const { showSuccess, showError, showWarning, showInfo } = useGlobalToast();

  const toast = {
    success: (message: string, options?: any) => {
      if (import.meta.client) {
        showSuccess('Success', message, options);
      }
    },
    error: (message: string, options?: any) => {
      if (import.meta.client) {
        showError('Error', message, options);
      }
    },
    warning: (message: string, options?: any) => {
      if (import.meta.client) {
        showWarning('Warning', message, options);
      }
    },
    info: (message: string, options?: any) => {
      if (import.meta.client) {
        showInfo('Info', message, options);
      }
    },
    clear: () => {
      if (import.meta.client) {
        // You can implement clear functionality if needed
      }
    }
  }

  return toast
}
